import { useDispatch, useSelector } from "react-redux";
import {
  quoteApplyDiscount,
  quoteResetDiscount,
} from "../redux/QuoteDiscountActions";
import { isEmpty } from "lodash";
import { getQuoteDiscountData } from "../redux/QuoteDiscountSelectors";

const useQuoteDiscounts = () => {
  const dispatch = useDispatch();
  const { discountCode, firstApplicationIntent } =
    useSelector(getQuoteDiscountData);

  const handleApplyDiscount = (discountCode) => {
    if (isEmpty(discountCode)) {
      return false;
    }
    dispatch(quoteApplyDiscount({ discountCode }));
  };

  const handleRemoveDiscount = () => {
    dispatch(quoteResetDiscount());
  };

  return {
    handleApplyDiscount,
    discountCode,
    firstApplicationIntent,
    handleRemoveDiscount,
  };
};

export default useQuoteDiscounts;
